"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const CommonInput = ({
  name,
  required,
  onChange,
  onBlur,
  onFocus,
  data,
  placeholder
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _classnames.default)({
    'intl-form-item': true,
    'rno-form-item': true,
    'rno-form-required': required,
    'rno-form-status-error': data.isError
  })
}, /*#__PURE__*/_react.default.createElement("label", {
  className: "form-component-label-s"
}, name, required && /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
  className: "rno-form-controls"
}, /*#__PURE__*/_react.default.createElement("input", {
  placeholder: placeholder,
  className: "rno-input",
  value: data.value || '',
  onChange: event => onChange(event.target.value),
  onBlur: onBlur,
  onFocus: onFocus
}), /*#__PURE__*/_react.default.createElement("div", {
  className: "rno-form-message"
}, data.errMsg || '')));
var _default = exports.default = CommonInput;